export { SearchResultsView } from "./SearchResultsView";
